import { render } from "./App.vue?vue&type=template&id=1eb08478"
const script = {}

import exportComponent from "/home/collin/workspace/hitech05/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__